"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var AvatarPicker_1 = require("components/AvatarPicker");
var avatars_1 = require("components/Avatar/avatars");
require("./step2.scss");
var component = function (props) { return (React.createElement("div", { key: 'step2', className: 'first-login-view-step2' },
    React.createElement(sok_ui_1.Tabs, { className: 'first-login-view-tabsbar', activeIndex: 0, onClick: function () {
            /* for lint */
        } },
        React.createElement("div", { key: 'tab' },
            React.createElement("label", null,
                React.createElement(Icon_1.Icon, { className: 'fa-user' }),
                ' ',
                (0, translation_1.getLocalization)('firstTimeLogin/step2/selectYourAvatar'))),
        React.createElement("div", { key: 'tab-content', className: 'tab-content' },
            React.createElement("div", { className: 'avatar-information' },
                React.createElement("div", { className: 'avatar-selection' }, props.firstLogin.avatar.length === 0 ? (React.createElement("div", null,
                    React.createElement(Icon_1.Icon, { key: 'user', className: 'fa-user' }))) : (React.createElement("img", { key: props.firstLogin.avatar, className: 'avatar-icon', src: (0, avatars_1.getAvatarUrl)(props.firstLogin.avatar) }))),
                React.createElement(AvatarPicker_1.AvatarPicker, { selectedAvatar: props.firstLogin.avatar, onAvatarPicked: props.selectUserAvatar })))))); };
exports.default = component;
